<template>
  <div>
    <template-breadcrumb-header-action-element>
      <template #content>
        <b-row>
          <a
            v-if="pptStatus && (isIndicaUser || isPNUDADMIN)"
            :href="pptUrl"
            class="exportPPT"
            target="_blank"
            size="sm"
            variant="primary"

            ><img width="40" src="static/icons/PPT.svg"
          /></a>
          <div
            v-if="!pptStatus && (isIndicaUser || isPNUDADMIN)"
            style="filter: saturate(0)"
            class="exportPPT"
            target="_blank"
            size="sm"
            variant="primary"
            @click="generatePtt()"
            :title="$t('label_download_PPT')"
          >
            <img width="40" src="static/icons/PPT.svg" />
        </div>
          <a
            v-if="pdfStatus"
            class="exportPDF"
            :href="pdfUrl"
            target="_blank"
            size="sm"
            variant="primary"
            ><img width="40" src="/static/icons/PDF.svg"
          /></a>
          <div
            v-if="!pdfStatus"
            style="filter: saturate(0)"
            class="exportPDF"
            target="_blank"
            size="sm"
            variant="primary"
            @click="generatePdf()"
            :title="$t('label_download_PDF')"
          >
            <img width="40" src="/static/icons/PDF.svg" />
          </div>
        </b-row>
      </template>
    </template-breadcrumb-header-action-element>
    <b-container>
      <b-row>
        <b-col lg="8">
          <card-general-index height="165px" />
        </b-col>
        <b-col>
          <card-conventions
            :height="mdScreen ? 'auto' : '165px'"
            :orientation="mdScreen ? 'horizontal' : ''"
            :show-ideal="false"
            :show-company="false"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <card-chart-treemap-with-comment
            :key="getPillarsLastUpdate"
            alias="treemap"
            @commentCreated="clearDownloadAndGetComments()"
          />
        </b-col>
      </b-row>

      <b-row
        v-if="comments && comments.length > 0 && (isIndicaUser || isPNUDADMIN)"
      >
        <b-col cols="12" lg="12">
          <b-card>
            <h4 class="card-title">
              {{ $t("label_reports_genderGap_recommendations") }}
            </h4>
            <div
              v-for="(comment, commentKey) in comments"
              :key="commentKey"
              style="white-space: pre-wrap"
            >
              {{ comment.comment
              }}<b-button
                size="sm"
                variant="link"
                class="mr-1"
                @click="openModal(comment, true)"
              >
                <img
                  src="../assets/images/edit_icon.svg"
                  style="width: 20px; height: 20px"
                />
              </b-button>
              <b-button
                size="sm"
                variant="link"
                class="mr-1"
                @click="openModal(comment, false)"
              >
                <img
                  src="../assets/images/delete_icon.svg"
                  style="width: 20px; height: 20px"
                />
              </b-button>
            </div>
            <b-modal v-model="showModal">
              <h5 style="margin-bottom: 20px">
                {{ $t("label_reports_genderGap_comments") }}
              </h5>
              <div v-if="!edit">
                {{ $t("label_reports_genderGap_comments_delete_confirmation")
                }}<br />{{ currentComment.comment }}
              </div>
              <div v-if="edit">
                {{ $t("label_reports_genderGap_comments_description") }}
              </div>

              <b-form-group v-if="edit" label-class="text-sm-left">
                <b-form-textarea
                  id="comment"
                  v-model="currentComment.comment"
                  type="text"
                  required
                />
              </b-form-group>

              <div slot="modal-footer" class="w-100" style="text-align: right">
                <b-button v-if="!edit" variant="primary" @click="saveComment()">
                  {{ $t("label_reports_comments_delete_button") }}
                </b-button>
                <b-button v-if="edit" variant="primary" @click="saveComment()">
                  {{ $t("label_evaluation_save_button") }}
                </b-button>
              </div>
            </b-modal>
          </b-card>
        </b-col>
      </b-row>

      <b-row style="display: flex; justify-content: center">
        <b-col
          v-for="(pillar, index) in pillarsIds"
          :key="index"
          md="6"
          lg="6"
          xl="4"
        >
          <card-chart-radar :pillar-id="pillar" alias="report" height="450px" />
        </b-col>
      </b-row>
    </b-container>
    <b-modal v-model="openDialog">
      <div v-if="modalType === 'pdf'">
        <div v-if="!pdfStatus">
          <h5 style="margin-bottom: 20px">
            {{ $t("label_reports_generate_report_title") }}
          </h5>
          <div>{{ $t("label_reports_generate_report") }}</div>
        </div>
        <div v-if="pdfStatus">
          <h5 style="margin-bottom: 20px">PDF report</h5>
          <div>
            Your report is ready. Click
            <a :href="pdfUrl" target="_blank">here</a> to download it.
          </div>
        </div>
      </div>
      <div v-if="modalType === 'ppt'">
        <div v-if="!pptStatus">
          <h5 style="margin-bottom: 20px">
            {{ $t("label_reports_generate_report_title") }}
          </h5>
          <div>{{ $t("label_reports_generate_report") }}</div>
        </div>
        <div v-if="pptStatus">
          <h5 style="margin-bottom: 20px">Power Point report</h5>
          <div>
            Your report is ready. Click
            <a :href="pptUrl" target="_blank">here</a> to download it.
          </div>
        </div>
      </div>

      <div slot="modal-footer" class="w-100" style="text-align: right">
        <b-button variant="primary" @click="openDialog = false">
          Close
        </b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { createHelpers } from "vuex-map-fields";
import CardChartTreemapWithComment from "./cards/CardChartTreemapWithComments";
import { axiosCall } from "@/utils/axiosCall";

const { mapFields } = createHelpers({
  getterType: "getUserAccountField",
  mutationType: "updateUserAccountField",
});

export default {
  name: "ReportsGenderGap",
  components: { CardChartTreemapWithComment },
  data: function () {
    return {
      mdScreen: false,
      pptStatus: false,
      pdfStatus: false,
      pptUrl: null,
      pdfUrl: null,
      openDialog: false,
      lastGenerationPpt: null,
      lastGenerationPdf: null,
      modalType: null,
      comments: [],
      edit: false,
      currentComment: {},
      showModal: false,
    };
  },
  beforeDestroy() {
    clearInterval();
  },
  created: async function () {
    await this.$store.dispatch("SNAPSHOTS_GET");
    await this.$store.dispatch("BUSINESS_GET");
    this.$store
      .dispatch("PILLARS_GET_REPORT")
      .then(() => {
      })
      .catch((err) => {
        console.log(err);
        //  this.$router.push('/home') // TODO Handle the error in a better way
      });
    await this.getComments();
    await this.checkExistence();
    this.checkAllFilesExist();
  },
  methods: {
    saveComment: async function () {
      if (this.edit) {
        await axiosCall({
          url: "GenderGapReportComments",
          method: "PUT",
          data: this.currentComment,
        });
      } else {
        await axiosCall({
          url: "GenderGapReportComments/" + this.currentComment.id,
          method: "DELETE",
        });
      }
      this.showModal = false;
      await this.clearDownloadAndGetComments();
    },
    clearDownloadAndGetComments: async function () {
      this.pptStatus = false;
      this.pdfStatus = false;
      this.pptUrl = null;
      this.pdfUrl = null;
      await this.getComments();
      await this.checkExistence();
      this.checkAllFilesExist();
    },
    getComments: async function () {
      const where = { where: {} };
      where.where["snapshotId"] = this.getCurrentSnapshot.snapshotId;
      where.where["general"] = true;
      console.log(where);
      await axiosCall({
        url: "GenderGapReportComments?filter=" + JSON.stringify(where),
        method: "GET",
      }).then((response) => {
        this.showModal = false;
        this.comments = response.data;
      });
    },
    openModal(comment, edit) {
      this.edit = edit;
      this.currentComment = { ...comment };
      this.showModal = true;
    },
    generatePtt: async function () {
      await axiosCall({
        url: `ReportGenerations/ppt/gender-gap/${this.getToken}/${this.getBusiness.id}/${this.getCurrentSnapshot.snapshotId}/${this.getCurrentAccountRoleId}/${this.lang}`,
      });
      this.modalType = "ppt";
      this.openDialog = true;
    },
    generatePdf: async function () {
      await axiosCall({
        url: `ReportGenerations/pdf/gender-gap/${this.getToken}/${this.getBusiness.id}/${this.getCurrentSnapshot.snapshotId}/${this.getCurrentAccountRoleId}/${this.lang}`,
      });
      this.modalType = "pdf";
      this.openDialog = true;
    },
    checkAllFilesExist() {
      setInterval(() => this.checkExistence(), 20000);
    },
    checkExistence: async function () {
      if (
        !this.pptStatus &&
        this.getToken &&
        this.getBusiness &&
        this.getBusiness.id &&
        this.getCurrentSnapshot &&
        this.getCurrentSnapshot.snapshotId &&
        this.getCurrentAccountRoleId
      ) {
        await axiosCall({
          url: `ReportGenerations/existsInAmazon/ppt/gender-gap/${this.getToken}/${this.getBusiness.id}/${this.getCurrentSnapshot.snapshotId}/${this.getCurrentAccountRoleId}/${this.lang}?noSpinner=true`,
        }).then((response) => {
          this.pptStatus = response.data.url.exists;
          this.pptUrl = response.data.url.url;
          this.lastGenerationPpt = response.data.url.last;
        });
      }
      if (
        !this.pdfStatus &&
        this.getToken &&
        this.getBusiness &&
        this.getBusiness.id &&
        this.getCurrentSnapshot &&
        this.getCurrentSnapshot.snapshotId &&
        this.getCurrentAccountRoleId
      ) {
        await axiosCall({
          url: `ReportGenerations/existsInAmazon/pdf/gender-gap/${this.getToken}/${this.getBusiness.id}/${this.getCurrentSnapshot.snapshotId}/${this.getCurrentAccountRoleId}/${this.lang}?noSpinner=true`,
        }).then((response) => {
          this.pdfStatus = response.data.url.exists;
          this.pdfUrl = response.data.url.url;
          this.lastGenerationPdf = response.data.url.last;
        });
      }
      if (this.pdfStatus && this.pptStatus) {
        clearInterval();
      }
    },
    uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          const r = (Math.random() * 16) | 0;
          const v = c === "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    ...mapFields(["username"]),
    ...mapGetters([
      "pillarsIds",
      "getBusiness",
      "getToken",
      "getCurrentSnapshot",
      "isPNUDADMIN",
      "getCurrentAccountRoleId",
      "isIndicaUser"
    ]),
  },
  mounted() {
    if (window.innerWidth <= 768) {
      this.mdScreen = true;
    }
  },
};
</script>
<style lang="scss">
</style>
<style lang="sass" scoped>

@import "../assets/css/variables.scss"

.positive
    background-color: $positive-color

.map
  position: relative
  margin-top: 20px
  .btn
    cursor: pointer
    position: absolute
    top: 0px
    right: 30px
    z-index: 100

h3
  font-size: 1.5rem
  margin-top: 20px

.col-lg-8, .col, .col-md-6, .col-lg-6, .col-xl-4
  padding-right: 5px
  padding-left: 5px
.card-title
  text-align: left
</style>
